import { render, staticRenderFns } from "./CreditForm.vue?vue&type=template&id=9ebd3076"
import script from "./CreditForm.vue?vue&type=script&lang=js"
export * from "./CreditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ebd3076')) {
      api.createRecord('9ebd3076', component.options)
    } else {
      api.reload('9ebd3076', component.options)
    }
    module.hot.accept("./CreditForm.vue?vue&type=template&id=9ebd3076", function () {
      api.rerender('9ebd3076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/Credit/components/CreditForm.vue"
export default component.exports